import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Actualiza el estado para que la próxima renderización muestre la UI de error
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Puedes registrar el error en un servicio de logging
    console.error('ErrorBoundary capturó un error:', error, errorInfo);
    
    this.setState({
      error: error,
      errorInfo: errorInfo
    });

    // Llamar al callback onError si existe
    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      // Usar el componente FallbackComponent si se proporciona
      if (this.props.FallbackComponent) {
        return (
          <this.props.FallbackComponent 
            error={this.state.error}
            errorInfo={this.state.errorInfo}
            resetErrorBoundary={() => this.setState({ hasError: false, error: null, errorInfo: null })}
          />
        );
      }

      // UI de error por defecto
      return (
        <div className="min-h-screen bg-secondary-50 dark:bg-secondary-900 flex items-center justify-center p-4">
          <div className="max-w-md w-full bg-white dark:bg-secondary-800 rounded-lg shadow-lg p-6">
            <div className="flex items-center justify-center w-16 h-16 bg-error-100 dark:bg-error-900/20 rounded-full mx-auto mb-4">
              <span className="text-2xl">⚠️</span>
            </div>
            
            <h2 className="text-xl font-semibold text-center text-secondary-900 dark:text-white mb-2">
              ¡Algo salió mal!
            </h2>
            
            <p className="text-secondary-600 dark:text-secondary-400 text-center mb-4">
              Ha ocurrido un error inesperado. Puedes intentar recargar la página.
            </p>
            
            <div className="flex gap-3">
              <button
                onClick={() => this.setState({ hasError: false, error: null, errorInfo: null })}
                className="flex-1 bg-primary-600 hover:bg-primary-700 text-white font-medium py-2 px-4 rounded-lg transition-colors duration-200"
              >
                Reintentar
              </button>
              <button
                onClick={() => window.location.reload()}
                className="flex-1 bg-secondary-200 dark:bg-secondary-700 hover:bg-secondary-300 dark:hover:bg-secondary-600 text-secondary-700 dark:text-secondary-300 font-medium py-2 px-4 rounded-lg transition-colors duration-200"
              >
                Recargar
              </button>
            </div>
            
            {/* Mostrar detalles del error en desarrollo */}
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details className="mt-4">
                <summary className="text-sm text-secondary-500 cursor-pointer">
                  Detalles del error (desarrollo)
                </summary>
                <div className="mt-2 p-3 bg-secondary-100 dark:bg-secondary-700 rounded text-xs">
                  <div className="text-error-600 dark:text-error-400 font-medium mb-2">
                    {this.state.error && this.state.error.toString()}
                  </div>
                  <pre className="text-secondary-600 dark:text-secondary-400 overflow-auto whitespace-pre-wrap">
                    {this.state.errorInfo.componentStack}
                  </pre>
                </div>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;